import { TransferRequest } from "./TransferRequest";

export default TransferRequest;
